var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B1557",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.272 4.268A2 2 0 0 0 17 3.26a2 2 0 1 0-3.728 1.008m0 0L4.728 9.252m0 0A2 2 0 0 0 1 10.26a2 2 0 0 0 3.728 1.008m0-2.016c.173.296.272.64.272 1.008 0 .367-.1.712-.272 1.008m0 0 8.544 4.984m0 0a2 2 0 1 1 3.454 2.014 2 2 0 0 1-3.454-2.014"
  })));
};
export default SvgShare;